(function () {
  let caveaInjected = false;

  const observer = new MutationObserver(function () {
    if (caveaInjected) return;

    const canvasEl = document.querySelector(".customer-canvas");
    if (!canvasEl) return;

    const discountCode = canvasEl.dataset.discount || "";
    const imageUrl = canvasEl.dataset.image || "";
    const dateTime = canvasEl.dataset.valid || "";

    const cdMovieTickets = document.querySelector("#customer_dashboard #cd_movie-tickets.cd_single_page .cd_container.cd_page_color");
    if (!cdMovieTickets) return;

    observer.disconnect();
    caveaInjected = true;

    /* ✅ CASE 1: Ticket Available */
    if (discountCode && imageUrl) {
      console.log("helo 2");

      const caveaBlock = document.createElement("div");
      caveaBlock.className = "cd_main_moview_teckets";

      if (discountCode) {
        const title = document.createElement("div");
        title.className = "h6";
        title.style.fontSize = "18px";
        title.style.marginBottom = "10px";
        title.textContent = `ფასდაკლების კოდი : ${discountCode}`;
        caveaBlock.appendChild(title);
      }

      if (dateTime) {
        const valid = document.createElement("div");
        valid.className = "h6";
        valid.style.fontSize = "18px";
        valid.style.marginBottom = "10px";
        valid.textContent = `მოქმედია : ${dateTime}`;
        caveaBlock.appendChild(valid);
      }

      const imageParent = document.createElement("div");
      const img = document.createElement("img");
      img.src = imageUrl;
      img.alt = "Movie Ticket";
      img.style.maxWidth = "100%";
      imageParent.appendChild(img);
      caveaBlock.appendChild(imageParent);

      cdMovieTickets.insertAdjacentElement("afterend", caveaBlock);
      return;
    }

    console.log("helo 3");

    /* ❌ CASE 2: No Ticket */
    const noTicketBlock = document.createElement("div");
    noTicketBlock.className = "no-ticket-card";
    noTicketBlock.innerHTML = `
      <div style="text-align:center; padding:30px; background:#fff; border-radius:14px; box-shadow:0 10px 30px rgba(0,0,0,.08); max-width:520px; margin:20px auto;">
        <div style="font-size:40px; margin-bottom:10px;">🎬</div>
        <h3 style="font-size:20px; margin-bottom:10px;">კინოთეატრის ბილეთები ვერ მოიძებნა</h3>
        <p style="font-size:15px; color:#555; margin-bottom:10px;">
          თქვენ არ გაქვთ კინოთეატრის ბილეთები მონიჭებული ან მონიჭებული ბილეთები უკვე გახარჯულია.
        </p>
        <p style="font-size:15px; color:#555;">
          ბილეთების მისაღებად გაეცანით პირობებს ქვემოთ მოცემულ ბმულზე.
        </p>
        <a href="https://ollivander.ge/pages/tkt" target="_blank"
          style="display:inline-block; margin-top:15px; padding:12px 22px; background:#000; color:#fff; border-radius:8px; text-decoration:none;">
          პირობების ნახვა
        </a>
      </div>
    `;
    cdMovieTickets.insertAdjacentElement("afterend", noTicketBlock);
  });

  observer.observe(document.body, { childList: true, subtree: true });
})();

document.addEventListener("DOMContentLoaded", function () {
  const translations = {
    "Way to earn": "ქულების დაგროვების წესები",
    "Activity": "ქულების საჩუქრები",
    "Transactions": "ტრანზაქციები",
    "Earning": "დარიცხვა",
    "Date": "თარიღი",
    "Event": "ტრანზაქციის ტიპი",
    "Amount": "ოდენობა",
    "Previous": "წინა",
    "Next": "შემდეგი",
    "Page": "გვერდი",
    "GEL": "₾",
  };

  const section = document.querySelector("#cd_store-credit.cd_main-section");
  if (!section) return;

  section.querySelectorAll("*").forEach(el => {
    if (el.children.length === 0) {
      let text = el.innerText.trim();
      if (translations[text]) {
        el.innerText = translations[text];
      }

      if (text.includes("GEL")) {
        el.innerText = text.replace("GEL", "₾");
      }
    }
  });
});

document.addEventListener("DOMContentLoaded", function () {

  const canvas = document.querySelector(".customer-canvas");
  const section = document.querySelector(".cd_main-section-1");

  if (!canvas || !section) return;

  const storeCredit = canvas.getAttribute("store-credit-ammount");

  if (!storeCredit) {
      const newBox = document.createElement("div");
  newBox.className = "cd_box";

  newBox.innerHTML = `
    <div class="cd_box-logo">
        <div class="cd_currency">
            <p>₾</p>
        </div>
        <div class="cd_box-content">
            <p>ქულების ბალანსი</p>
            <p>0.00 ₾</p>
        </div>
    </div>
  `;

  // append new box at end
  section.appendChild(newBox);
  return 0;
  };

  // currency symbol extract (auto detect)
  const symbol = storeCredit.replace(/[0-9.,\s]/g, '');

  // new box create
  const newBox = document.createElement("div");
  newBox.className = "cd_box";

  newBox.innerHTML = `
    <div class="cd_box-logo">
        <div class="cd_currency">
            <p>${symbol}</p>
        </div>
        <div class="cd_box-content">
            <p>ქულების ბალანსი</p>
            <p>${storeCredit}</p>
        </div>
    </div>
  `;

  // append new box at end
  section.appendChild(newBox);

});